import React, { useState } from "react";
import axios from "axios";
import "../community.css";
import "../ai.css";
import { useParams, Link } from "react-router-dom";

/* ==========================================================
   Career Advisor Tool
   ========================================================== */

function CareerAdvisor() {
  const [topic, setTopic] = useState("");
  const [advice, setAdvice] = useState("");
  const [loading, setLoading] = useState(false);

  const apiBase = process.env.REACT_APP_API_URL;
  const MAX_CHARS = 6000;

  /* ==========================================================
     Validate + Send Career Topic to API
     ========================================================== */
  const getAdvice = async () => {
    if (!topic.trim()) {
      alert("Describe your career question or situation.");
      return;
    }

    if (topic.length > MAX_CHARS) {
      alert("Your message is too long. Try summarizing your career question.");
      return;
    }

    setLoading(true);
    setAdvice("");

    try {
      const res = await axios.post(`${apiBase}/api/ai-career-advisor`, {
        topic,
      });

      setAdvice(res.data.advice);
    } catch (err) {
      console.error("Career advisor error:", err);
      setAdvice(
        "An error occurred while generating advice. Please try again."
      );
    }

    setLoading(false);
  };

  /* ==========================================================
     UI RENDER
     ========================================================== */

  return (
    <div className="ai-tool-wrapper">
      <Link to="/community">
  <button className="back-btn">← Back to Community</button>
</Link>
      <h2 className="ai-tool-title">📊 Career Advisor</h2>

      {/* USER INPUT FIELD */}
      <textarea
        className="ai-input"
        placeholder="Describe your career question, job search challenge, or long-term goal..."
        value={topic}
        onChange={(e) => setTopic(e.target.value)}
        maxLength={MAX_CHARS}
      />

      {/* CHARACTER COUNTER */}
      <div className="char-counter">
        {topic.length} / {MAX_CHARS}
      </div>

      {/* SUBMIT BUTTON */}
      <button className="ai-btn" onClick={getAdvice} disabled={loading}>
        {loading ? "Analyzing..." : "Get Advice"}
      </button>

      {/* AI OUTPUT */}
      {advice && (
        <div className="ai-output">
          <h3 className="ai-output-title">Advice</h3>
          <pre className="ai-output-box">{advice}</pre>
        </div>
      )}
    </div>
  );
}

export default CareerAdvisor;

